<ng-template #successTitleWithIcon>
  <span class="notification-title-container">
    <svg-icon src="assets/icons/success-not.svg"></svg-icon>
    <span>{{ title }}</span>
  </span>
</ng-template>
<ng-template #errorTitleWithIcon>
  <span class="notification-title-container">
    <svg-icon src="assets/icons/error-not.svg"></svg-icon>
    <span>{{ title }}</span>
  </span>
</ng-template>
<ng-template #warningTitleWithIcon>
  <span class="notification-title-container">
    <svg-icon src="assets/icons/warn-not.svg"></svg-icon>
    <span>{{ title }}</span>
  </span>
</ng-template>
